import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { UtilityService } from '../../service/utility.service';
import {
  PortalFeatureDirective,
  PortalLoginRequiredDirective,
  PortalButtonDirective,
} from '../../directives';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PortalFeatureDirective,
    PortalLoginRequiredDirective,
    PortalButtonDirective,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit {
  constructor(private utilityService: UtilityService) {}

  LoggedIn = JSON.parse(localStorage.getItem('login') || 'false');
  slides = [
    { image: '../../assets/img/banner/body_background.jpg', alt: 'Slide 1' },
  ];
  currentSlide = 0;
  nextSlideIndex = 1;
  isAnimating = false;
  ngOnInit(): void {
    this.autoSlide();
  }

  nextSlide(): void {
    if (this.isAnimating) return;
    this.isAnimating = true;
    this.nextSlideIndex = (this.currentSlide + 1) % this.slides.length;

    setTimeout(() => {
      this.currentSlide = this.nextSlideIndex;
      this.nextSlideIndex = (this.currentSlide + 1) % this.slides.length;
      this.isAnimating = false;
    }, 600);
  }

  prevSlide(): void {
    if (this.isAnimating) return;
    this.isAnimating = true;
    this.nextSlideIndex =
      (this.currentSlide - 1 + this.slides.length) % this.slides.length;

    setTimeout(() => {
      this.currentSlide = this.nextSlideIndex;
      this.nextSlideIndex = (this.currentSlide + 1) % this.slides.length;
      this.isAnimating = false;
    }, 600);
  }

  goToSlide(index: number): void {
    if (this.isAnimating || index === this.currentSlide) return;
    this.isAnimating = true;
    this.nextSlideIndex = index;

    setTimeout(() => {
      this.currentSlide = this.nextSlideIndex;
      this.nextSlideIndex = (this.currentSlide + 1) % this.slides.length;
      this.isAnimating = false;
    }, 600);
  }

  autoSlide(): void {
    if (this.slides.length > 1) {
      setInterval(() => this.nextSlide(), 4000);
    } else {
      this.nextSlide();
    }
  }

  // Direct access to portal configuration
  get portalConfig() {
    return this.utilityService.portalConfig;
  }
}
